module.exports = __webpack_public_path__ + "img/plan-3-free-bt.fc34ebbe.png";